import React, { Fragment, useState, useEffect } from "react";
import { IconCalendar, IconChevronDown, IconDownload } from "@tabler/icons-react";
import { CommonUtils, DatetimeUtils } from "utils";
import "chart.js/auto";
import { useStatisticGroupGet } from "hooks";
import { useTranslation } from "react-i18next";
import { LangConstant, SystemConstant } from "const";
import { Pagination } from "components";
import SelectDateTime from "./SelectDateTime";

const GroupStatistic = () => {
  const { t: getLabel } = useTranslation();
  const { getStatisticGroup } = useStatisticGroupGet();

  const [labelCalendar, setLabelCalendar] = useState(getLabel(LangConstant.TXT_DATE_TODAY));
  const [sinceTime, setSinceTime] = useState(CommonUtils.getStartToday());
  const [lastTime, setLastTime] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [dataGroupStatistic, setDataGroupStatistic] = useState([]);

  const [openDateTime, setOpenDateTime] = useState(false);

  const maxRowPerPage = 10;

  const onChangePage = newPage => {
    setPage(newPage);
  };

  const onExport = async () => {
    const payload = {
      export_f: 1,
    };
    if (sinceTime) {
      payload.since_time = sinceTime;
    }
    if (lastTime) {
      payload.last_time = lastTime;
    }

    const response = await getStatisticGroup(payload);
    if (response) {
      const link = document.createElement("a");
      link.href = response;
      link.download = "Tong_quan_hoat_dong.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const payload = {
        paging: 1,
        limit: maxRowPerPage,
        offset: (page - 1) * maxRowPerPage,
      };
      if (sinceTime) {
        payload.since_time = sinceTime;
      }
      if (lastTime) {
        payload.last_time = lastTime;
      }

      const response = await getStatisticGroup(payload);
      if (response) {
        setDataGroupStatistic(response.data.data);
        setTotalPage(response.data.total_pages);
      }
    };

    fetchData();
  }, [page, sinceTime, lastTime]);

  return (
    <Fragment>
      <div className="d-flex justify-content-between align-items-center pb-2 mb-2 border-bottom">
        <h3 className="m-0">{getLabel(LangConstant.TXT_STATISTIC_GROUP_OVERVIEW)}</h3>
        <div className="d-flex gap-3 position-relative">
          <div
            className="btn btn-outline-secondary d-flex align-items-center gap-2"
            style={{ minWidth: "200px", maxWidth: "250px" }}
            onClick={() => setOpenDateTime(!openDateTime)}
          >
            <IconCalendar size={18} />
            <span className="flex-grow-1">{labelCalendar}</span>
            <IconChevronDown size={16} />
          </div>

          <div style={{ position: "absolute", zIndex: 4, top: "42px", right: "166px" }}>
            <SelectDateTime
              open={openDateTime}
              setLabel={setLabelCalendar}
              onClose={() => setOpenDateTime(false)}
              setSinceTime={setSinceTime}
              setLastTime={setLastTime}
            />
          </div>

          <button className="btn btn-primary d-flex align-items-center gap-2" onClick={onExport}>
            <IconDownload size={16} />
            {getLabel(LangConstant.TXT_STATISTIC_EXPORT)}
          </button>
        </div>
      </div>

      <div className="table-responsive my-3">
        <table className="table table-vcenter card-table">
          <thead>
            <tr>
              <th style={{ width: "5%" }} className="text-center">{getLabel(LangConstant.TXT_STATISTIC_COL_STT)}</th>
              <th style={{ width: "15%" }} className="text-center">{getLabel(LangConstant.TXT_STATISTIC_COL_TYPE)}</th>
              <th style={{ width: "20%" }} className="text-center">{getLabel(LangConstant.TXT_STATISTIC_COL_NAME)}</th>
              <th style={{ width: "20%" }} className="text-center">{getLabel(LangConstant.TXT_STATISTIC_COL_MEMBER_COUNT)}</th>
              <th style={{ width: "20%" }} className="text-center">{getLabel(LangConstant.TXT_STATISTIC_COL_TOTAL_MESSAGES)}</th>
              <th style={{ width: "20%" }} className="text-center">{getLabel(LangConstant.TXT_STATISTIC_COL_LAST_ACTIVE)}</th>
            </tr>
          </thead>
          <tbody>
            {dataGroupStatistic?.length > 0 ? (
              dataGroupStatistic.map((data, index) => (
                <tr key={index}>
                  <td className="text-center">{maxRowPerPage * (page - 1) + index + 1}</td>
                  <td className="text-center">{getLabel(SystemConstant.GROUP_TYPE_NAME[data.group_type])}</td>
                  <td className="text-center" style={{ whiteSpace: "normal", overflowWrap: "break-word" }}>
                    {data.group_name}
                  </td>
                  <td className="text-center">{data.total_account}</td>
                  <td className="text-center">{data.total_message}</td>
                  <td className="text-center">{DatetimeUtils.convertMillisecondsToDateTime(data.last_active)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="text-center">
                  <small><em>{getLabel(LangConstant.TXT_NOT_FOUND)}</em></small>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {dataGroupStatistic.length > 0 && (
        <Pagination currentPage={page} totalPages={totalPage} onPageChange={(e, p) => onChangePage(p)} />
      )}

      <p className="text-secondary small">
        {getLabel(LangConstant.TXT_STATISTIC_DATA_UPDATED_AT, { time: DatetimeUtils.convertMillisecondsToDateTime(Date.now()) })}
      </p>
    </Fragment>
  );
};

export default GroupStatistic;
